import React, { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import TextArea from 'antd/lib/input/TextArea';
import { Button, Col, Input, Row } from 'antd';
import '@ant-design/compatible/assets/index.css';
import CustomInputSearch from '@iso/components/utility/customInputSearch.js';
import { formatarDocument, formatPhoneNumber, onlyNumber, testEmpty, findObjIntoArrayByProp } from '@iso/lib/helpers/utility';

export default function SelectClient(props) {

    const [reload, setReload] = useState(false);
    const [options, setOptions] = useState([]);
    const [client, setClient] = useState((props?.currentOrder?.client !== null) ? props?.currentOrder?.client : {'name':'', 'cpf_cnpj':''});

    useEffect(() => {
        iteratePeoples(props.clients)
    }, []);

    const onChangeVal = (f, v) => {
        setClient(prev => {
            prev[f] = v;
            return prev;
        })
        setReload(!reload)
    }

    const handleOnSelect = (item) => {
        var index = findObjIntoArrayByProp(options, 'id', item.id);
        if (index != -1)
            setClient(options[index]);
    }

    const beforeMaskedValueChange = (newState, oldState, userInput) => {
        var { value } = newState;
        var selection = newState.selection;
        var cursorPosition = selection ? selection.start : null;

        // keep minus if entered by user
        if (value.endsWith('--') && userInput !== '--' && !this.state.value.endsWith('--')) {
            if (cursorPosition === value.length) {
                cursorPosition--;
                selection = { start: cursorPosition, end: cursorPosition };
            }
            value = value.slice(0, -1);
        }

        return {
            value,
            selection
        };
    }

    const showAddress = (ref) => {
        let r = '';

        if(typeof ref.address !== 'undefined') {
            if(typeof ref.address.address !== 'undefined')
                r += ref.address.address+', ';
            if(typeof ref.address.numberHouse !== 'undefined')
                r += ref.address.numberHouse+', ';
            if(typeof ref.address.city !== 'undefined')
                r += ref.address.city+'/';
            if(typeof ref.address.state !== 'undefined')
                r += ref.address.state;
        }

        return r;
    }

    const iteratePeoples = (data) => {
        setOptions(data.map(el => ({
            'id':el._id,
            'name':el.name,
            'address':el.address,
            'cpf_cnpj':el.cpf_cnpj,
            'label':`${el.name} | ${formatPhoneNumber(testEmpty(el.fone, ''))} | ${formatarDocument(testEmpty(el.cpf_cnpj, ''))}`, //   | ${testEmpty(el.email, '-')}
            'normalized': `${el.name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")} | ${formatPhoneNumber(testEmpty(el.fone, ''))} | ${formatarDocument(testEmpty(el.cpf_cnpj, ''))}` //   | ${testEmpty(el.email, '-')}
        })));
    }

    const close = () => {
        props.cancel()
    }

    const setClientToOrder = () => {
        let a = {...client};
        delete a.label;
        delete a.normalized;
        delete a.address;
        props.onChange('client', a);
        close()
    }

    return (
        <Row gutter={24} className='contentSelectClientInputs'>
            <Col span={24} className='textLeft'>Selecione o cliente ou informe manualmente:</Col>
            <Col span={24}>
                <CustomInputSearch
                    autoFocus={'autoFocus'}
                    items={options}
                    onSelect={handleOnSelect}
                    placeholder='Digite para buscar'
                    className="reactSearch"
                />
            </Col>
            <br clear="both"/>
            <Col span={8}>Nome:</Col>
            <Col span={16}>
                <Input type='text' value={client?.name} onChange={(e) => { onChangeVal('name', e.target.value) }} />
            </Col>
            <Col span={8}>CPF / CNPJ:</Col>
            <Col span={16}>
                <InputMask
                    name='cpf_cnpj'
                    maskChar={''}
                    className='ant-input'
                    value={client?.cpf_cnpj}
                    mask={onlyNumber(client?.cpf_cnpj).length < 12 ? "999.999.999-999" : "99.999.999/9999-99"}
                    onChange={(e) => { onChangeVal('cpf_cnpj', e.target.value); }}
                    beforeMaskedValueChange={beforeMaskedValueChange}
                />
            </Col>
            <Col span={8}>Endereço:</Col>
            <Col span={16}>
                <TextArea rows={5} disabled={'disabled'} value={ showAddress(client) } style={{marginBottom:'15px'}}/>
            </Col>
            <Col span={12}>
                <Button onClick={setClientToOrder} type="primary" className='fullWidth'>Confirmar</Button>
            </Col>
            <Col span={12}>
                <Button onClick={close} type="danger" className='fullWidth'>Cancelar</Button>
            </Col>
        </Row>
    )
}